import apiClient from './api';
import { Trainee } from '../types/trainee'; // تأكد من وجود هذا النوع
import { PagedResult, TableParams } from '../hooks/useServerSideTable'; // استيراد الأنواع من hook الجدول
import { Lawyer } from '../types/lawyer'; // <-- (1) قم بإنشاء هذا النوع

// نوع بيانات المتدرب الجديد (بدون id أو العلاقات المعقدة)
export interface NewTraineeData {
  user_id: number;
  name: string;
  trainee_number: string;
  lawyer_id: number;
  start_date: string;
  end_date: string;
}
/**
 * جلب قائمة المتدربين مع دعم للترقيم والبحث والفرز
 */
export type UpdateTraineeData = Partial<NewTraineeData>;


export const getPagedTrainees = async (params: TableParams): Promise<PagedResult<Trainee>> => {
  const response = await apiClient.get<{ data: PagedResult<Trainee> }>('/trainees/paged', { params });
  return response.data.data;
};


/**
 * (2) إنشاء متدرب جديد
 */
export const createTrainee = async (traineeData: NewTraineeData): Promise<Trainee> => {
  const response = await apiClient.post<{ data: Trainee }>('/trainees', traineeData);
  return response.data.data;
};

/**
 * (3) جلب قائمة بجميع المحامين (لاختيار المشرف)
 */
export const getAllLawyers = async (): Promise<Lawyer[]> => {
  // تأكد من أن لديك مسار API صحيح لجلب جميع المحامين
  const response = await apiClient.get<{ data: Lawyer[] }>('/lawyers'); 
  return response.data.data;
};


export const getTraineeById = async (id: number): Promise<Trainee> => {
  const response = await apiClient.get<{ data: Trainee }>(`/trainees/${id}`);
  return response.data.data;
};

/**
 * (2) تحديث متدرب موجود
 */
export const updateTrainee = async (id: number, traineeData: UpdateTraineeData): Promise<Trainee> => {
  const response = await apiClient.put<{ data: Trainee }>(`/trainees/${id}`, traineeData);
  return response.data.data;
};
// ... (يمكن إضافة دوال أخرى هنا لاحقاً مثل updateTraineeStatus)
export const deleteTrainee = async (id: number): Promise<void> => {
  await apiClient.delete(`/trainees/${id}`);
};